import React, { Component, createRef } from 'react';


import { grey, purple } from '@mui/material/colors';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import moment from 'moment';
import { ResponsiveContainer} from 'recharts';
import { MapContainer, TileLayer, Marker, Popup, GeoJSON } from 'react-leaflet';
import L, { LatLngBoundsExpression } from 'leaflet';
//import 'leaflet/dist/leaflet.css';
import icon from 'leaflet/dist/images/marker-icon.png';
import iconShadow from 'leaflet/dist/images/marker-shadow.png';

import PageBase from '../site/PageBase';
//import LiveMap from './LiveMap';
import {apipost, apiraw, bizpost} from '../../ajax';
import { LatLngExpression } from 'leaflet';
import metericon from '../icons/meter.png';
import apply from '../icons/receipt.svg';
import pay from '../icons/pay-per-click.svg';
import submit from '../icons/submit.svg';
import process from '../icons/thinking.svg';
import complete from '../icons/task-complete.svg';
import { Box } from '@mui/material';
import BadgeMarker, { AnimatedBadgeMarker } from '../maps';
import { greyIcon } from '../icons';

const s:any = {
  root: {
    flexGrow: 1,
    flexShrink: 1,
  },
  // navigation: {
  //   fontSize: 15,
  //   fontWeight: 300,
  //   color: grey['600'],
  //   paddingBottom: 15,
  //   display: 'block'
  // },
  // title: {
  //   fontSize: 24,
  //   fontWeight: 300,
  //   marginBottom: 20,
  //   color:'white'
  // },
  // paper: {
  //   padding: 5,
  // },
  // clear: {
  //   clear: 'both'
  // },
  boardpaper: {
    backgroundColor: 'white',
    //maxHeight: 600,
    height: '100%',
    // height: 150
    // marginLeft: 10,
    // marginRight: 10,
  },
  div: {
    // height: 95,
    //padding: '5px 15px 0 15px'
  },
  header: {
    fontSize: 24,
    fontWeight: 'typography.fontWeightLight',
    color: 'white',
    backgroundColor: purple['600'],
    padding: 10,
  }
};

const ntrmsicons:any = {
  REQUEST:L.icon({iconUrl:apply,shadowUrl:iconShadow}),
  PAYMENT:L.icon({iconUrl:pay,shadowUrl:iconShadow}),
  SUBMISSION:L.icon({iconUrl:submit,shadowUrl:iconShadow}),
  PROCESSING:L.icon({iconUrl:process,shadowUrl:iconShadow}),
  SUBTASK:L.icon({iconUrl:process,shadowUrl:iconShadow}),
  COMPLETE:L.icon({iconUrl:complete,shadowUrl:iconShadow}),
  DELIVERY:L.icon({iconUrl:complete,shadowUrl:iconShadow}),
}

let DefaultIcon = L.icon({
  iconUrl: icon,
  shadowUrl: iconShadow
});

L.Marker.prototype.options.icon = DefaultIcon;

const MapIcon:L.Class = L.Icon.extend({
  options: {
    iconUrl: metericon,
    iconSize: [7.5, 7.5],
    iconAnchor: [0, 0]
  }
});

class Mapboard extends Component<any,any> {
  static propTypes: any;
  static defaultProps: any;
  map: any;
  constructor(props:any) {
    super(props);

    this.map = createRef();

    const {mapper={}} = this.props;
    const {cc=[5.64046614, -0.2921927]} = mapper;
    const {bb=[[4.71046214438, -3.24437008301],[11.0983409693, 1.0601216976]]} = mapper;
    const mcenter:LatLngExpression = cc; //||[8.977850, 39.253099];
    const mpos:LatLngExpression = cc; //||[9.01055, 38.74750];
    const mtext = `NTRMS Event. <br /> Event Location.`;
    const mbounds:LatLngBoundsExpression = bb;
    const mzoom = 13;
    const mtitle = 'Event Map';
        
    const {title=mtitle,mapcenter=mcenter,mapbounds=mbounds,mapzoom=mzoom,mappos=mpos,maptext=mtext,markerpos=mpos,markertext=mtext} = props;

    this.state = {
      //dd: this.props.userData.dd,
      ping: null,
      timer: 60000, //300000,
      count:0,
      offset: 0,
      limit: 1000,
      loading: false,
      lastread: null,
      recordset: [],
      previousset:[],
      currentset:[],
      maplayer: null,
      center:[5.64046614, -0.2921927],
      zoom: 13,

      mtitle:title,
      mcenter:mapcenter,
      mbounds:mapbounds,
      mzoom:mapzoom,
      mpos:mappos,
      mtext:maptext,
      mkpos:markerpos,
      mktet:markertext,
    };
  }

  // componentDidMount(): void {
  //   // const map = useMap()
  //   // console.log('map center:', map.getCenter())
  //   // return null
  //   const cmap = this.map.current;
  //   console.log('map',cmap);
  //   cmap.on('zoomend',this.onZoom);

  // } 

  componentDidMount() {
    const cmap = this.map.current;
    console.log('map',cmap);
    //cmap.on('zoomend',this.onZoom);
    this.baseload();
    //
    const {timer } = this.state;
    var ping = setInterval(this.refresh,timer);
    this.setState({ ping: ping });
  }

  componentWillUnmount() {
    if (this.state.ping) clearInterval(this.state.ping);
  }

  refresh = async() => {
    try {
      const {center:ocenter,recordset:previousset,lastread} = this.state;
      const {offset:ofs,limit:lim} = this.state;
      const baseparams = { s: "mapboard", a: "get",ofs,lim };
      const response = await bizpost(baseparams);
      const {cc:ncenter,rc,sd:currentset} = response;
      const recordset = this.merge('rid',previousset,currentset);
      const offset = ofs+rc;
      const center = ncenter || ocenter;
      this.setState({center,recordset,previousset,currentset,offset});
    } catch (error) {
      console.log("refresh error", error);
      this.sessionError(error);
    }
  }

  sessionError(error: any) {
    const { type, name, title, data } = error || {};
    if (type === "error" && name === "fetcherror" && title === "Unauthorised") {
      const { failure, code } = data || {};
      if (failure === true && code === 401) {
        //session expired. reload page.
        //this.props.doRestart('Session Expired. reloading...');
        // eslint-disable-next-line no-restricted-globals
        location.reload();
      }
    }
  }

  // componentDidMount(){
  //   const {timer} = this.state;
  //   var ping = setInterval(async()=>{
  //     try{
  //       const baseparams = {s:'security',a:'dashdata'};
  //       const response = await bizpost(baseparams);
  //       //console.log('dd resp',response);
  //       this.setState({dd:response.dd});
  //     }
  //     catch(error){
  //       console.log('dd error',error);
  //     } 
  //   },timer);
  //   this.setState({ping:ping});
  // }

  // componentWillUnmount(){
  //   if(this.state.ping) clearInterval(this.state.ping);
  // }

  mapload = async(file:string) => {
    try{
      const baseparams = {file}; //,sta:date
      const response = await apiraw('/api/resource/maps','',baseparams);
      //this.setState({markers:response.sd});
      //this.map.addLayer(this.liveLayer);
      //this.liveLayer.clearLayers();
      //this.loadMakersLeaflet();
      return response; //TODO: return file
    }
    catch(error){
      console.log('mapload error',error);
      return Promise.reject(error);
    } 
  //TODO: call LoadMarkers
  
  }

  baseload = async() => {
    try{
      const rs = await this.mapload('ghana_regions.json');
      console.log('baselayer',rs);
      this.setState({maplayer:rs});
    }
    catch(error){
      console.log('baseload error',error);
      return Promise.reject(error);
    } 
  }

  placesload = async() => {
    try{
      return await this.mapload('ghana-towns.json');
    }
    catch(error){
      console.log('placesload error',error);
      return Promise.reject(error);
    } 
  }

  merge = (p:string, ...arrs:any[]) => [].concat(...arrs).reduce((a, b) => !a.filter(c => b[p] === c[p]).length ? [...a, b] : a, []);


  // liveLoad = async(code:any,date:any) => {
  //     try{
  //       const {recordset:previousset,lastread} = this.state;
  //       const {userData} = this.props || {};
  //       const {eni} = userData;
  //       //const start = moment.format()
  //       //TODO: I am hardcoding code and start until baseparams is properly fixed. start is a timestamp so it will 
  //       // not accept empty string. either null or a valid timestamp
  //       const baseparams = {s:'marker',a:'find',eni,stp:lastread}; //,sta:date, ,cod:'1M8wJEWIAcIEfILnCHpISD'
  //       const response = await bizpost(baseparams);
  //       const {sd:currentset} = response;
  //       const recordset = this.merge('rid',previousset,currentset);
  //       this.setState({recordset,previousset,currentset});
  //       //this.map.addLayer(this.liveLayer);
  //       //this.liveLayer.clearLayers();

  //       //this.loadMakersLeaflet();
  //     }
  //     catch(error){
  //       console.log('map.bizpost error',error);
  //     } 
  //   //TODO: call LoadMarkers
    
  // }

  ttFormatTime = (stamp:any) => {
    return moment.unix(stamp).format('DD MMM');
  }

  onZoom = () => {
    try{
      const actualZoom = this.map.getZoom();
      const newSize = 60/((20 - actualZoom )*2);
      //const resizedIcon = new MapIcon({iconSize: [newSize, newSize ]});      
      //marker.setIcon(resizedIcon );
    }
    catch(err){
      console.log('Map Zoom Error:', err);
    }
  }

  addLayer = (layer:any) => {
    this.map.addLayer(layer);
    layer.clearLayers();
    this.loadMarkers();
  }

  loadMarkers = () => {}

  render() {
    const {userData,classes,theme} = this.props;
    const {maplayer} = this.state;
    //const {recordset,previousset,currentset} = this.state;
    const {mtitle,mcenter,mbounds,mzoom,mpos,mtext,mkpos,mktext} = this.state;
    console.log('userData',userData);

    const {mapzoom=mzoom,mappos=mpos,maptext=mtext,markerpos=mkpos} = this.props;
    const {title=mtitle,recordset=[],mapcenter=mcenter,mapbounds=mbounds} = this.props;

    const {bd} = userData ||{};
    //const mcenter:LatLngExpression = center||[8.977850, 39.253099]; 
    //const mpos:LatLngExpression = center||[9.01055, 38.74750];
        
    //const mapcenter:LatLngExpression = center; //[7.5823, -1.9470];
    //const apexpos:LatLngExpression = [9.01055, 38.74750]; //[6.647991, -0.579113];
    const apextext = `NTRMS Event.`;
    //const bounds = new  L.LatLngBounds([[4.5392525, -3.260786],[11.1748562,	1.2732942]]);
    //const bounds:LatLngBoundsExpression = [[4.5392525, -3.260786],[11.1748562,	1.2732942]];
    //-3.24437008301, 4.71046214438, 1.0601216976, 11.0983409693
    //const bounds:LatLngBoundsExpression = [[4.71046214438, -3.24437008301],[11.0983409693, 1.0601216976]];
    const npos:LatLngExpression = [5.54959014, -0.1964927]; //default
    const gpos:LatLngExpression = [5.57059614, -0.1924027]; //green
    const fpos:LatLngExpression = [5.62590614, -0.1801927]; //gold
    const bpos:LatLngExpression = [5.66296614, -0.1534027]; //red
    const bounds:LatLngBoundsExpression = [[5.01046214438, -3.24437008301],[11.3983409693, 1.0601216976]];
    const center:LatLngExpression = [5.60046614, -0.1821927];
    const zoom = 12;


    return (
      <PageBase navigation="NTRMS / Map board" subid={(bd||{}).eni}>
      <Box sx={{...s.root}}>
        <Grid container spacing={{xs:1, sm:3}}>
          <Grid size={{xs:12}}>
            {/* <LiveMap /> */}
            <Paper sx={{...s.boardpaper}}>
              <Box sx={{...s.header}}>{title}</Box>
              <Box sx={{...s.div}}>
                <ResponsiveContainer >
            <MapContainer 
              ref={this.map} 
              center={center} 
              zoom={zoom} 
              scrollWheelZoom={false} 
              style={{height:'100vh',width:'90vw'}} 
              bounds={bounds}>
              <TileLayer
                attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" bounds={bounds}
              />
              <GeoJSON attribution="&copy; credits due..." data={maplayer} />
              {/* <BadgeMarker
                position={[5.6037, -0.1870]}
                badgeValue={12}
                badgeColor="purple"
                onClick={() => alert("Marker clicked!")}
              /> */}
              {/* <BadgeMarker
                position={[5.6, -0.18]}
                value="99+"
                sx={{ fontWeight: "bold", backgroundColor: "#673ab7" }}
                animate={true}
              /> */}
              <AnimatedBadgeMarker
                position={[5.6, -0.18]}
                value={7}
                badgeColor="#651fff"
                textColor="#fff"
                sx={{ fontWeight: "bold" }}
              />
              <Marker position={npos} icon={greyIcon}>
                <Popup>
                  {maptext}
                </Popup>
              </Marker>
              <Marker position={bpos} icon={greyIcon}>
                <Popup>
                  {maptext}
                </Popup>
              </Marker>
              <Marker position={fpos} icon={greyIcon}>
                <Popup>
                  {maptext}
                </Popup>
              </Marker>
              <Marker position={gpos} icon={greyIcon}>
                <Popup>
                  {maptext}
                </Popup>
              </Marker>
              {recordset.map((record:any, idx:number) => 
                <Marker key={record.rid} position={record.geo} icon={ntrmsicons[record.evc]}>
                <Popup>
                  <Box component='span'>TRACK:{record.tri}<br/>REF:{record.rfn}<br/>MDA:{record.enc}<br/>EVENT: {record.evc}<br/>ACTIVITY: {record.acc}<br/>STATUS: {record.vsc}<br/>DATE: {record.dcd}</Box>
                </Popup>
              </Marker>
              )}
            </MapContainer>
          </ResponsiveContainer>
              </Box>
            </Paper>
            
          </Grid>
        </Grid>
      </Box>
      </PageBase>
    );
  }
};

export default Mapboard;
